import { useMemo } from 'react';
import { useApi } from '../../../providers/ApiProvider'
import ProjectMembersSystem from './ProjectMembersSystem';
import { useReduxTanStackSync } from '../../../providers/ReduxTanStackSyncProvider';

const useProjectMembersSystem = () => {
	const api = useApi();
	const sync = useReduxTanStackSync();

	return useMemo( () => new ProjectMembersSystem( { api, sync } ), [ api, sync ] );
}

export default useProjectMembersSystem;
